// GSAP + ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

const mm = gsap.matchMedia();

// optional: turn on markers while debugging
// ScrollTrigger.defaults({ markers: true });

// ensure layout is final before measuring (images, fonts)
window.addEventListener("load", () => ScrollTrigger.refresh());

// < 441px
mm.add("(max-width: 440px)", () => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".kg-met-image-container",
      start: "top top",
      end: "bottom bottom",
      scrub: 1.5,
      // toggleActions is ignored when scrub is set; safe to omit
    },
  });

  tl.to(".kg-animated-image", { x: 40, y: 20, duration: 0.5 });
});

// ≥ 441px
mm.add("(min-width: 441px)", () => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".kg-met-image-container",
      start: "top top",
      end: "bottom bottom",
      scrub: 1.5,
    },
  });

  tl.to(".kg-animated-image", { x: 70, y: 40, duration: 0.5 });
});
